import emailVerifyImg from "../../assests/images/emailVerify.webp"
import { EmailModalHeading } from "../TextInputUtils"
import { EmailModalDescription } from "../TextInputUtils"

const EmailVerificationModal = () => {
   return (
    <div class="d-flex flex-column justify-content-center px-3">
    <div class="align-self-center mb-4">
    <img src={emailVerifyImg} alt="eamilVerify-image" class="img-fluid" style={{height: "70px"}}/>
    </div>
    <h2 class="text-center fw-bold">{EmailModalHeading}</h2>
    <p class="text-center">{EmailModalDescription}</p>
    </div>
   )
}


export default EmailVerificationModal